import Vue from "vue";

if (document.getElementById('app-offer-erecruter')) {

    var id = null;
    var queryString = window.location;

    if (queryString) {
        var url = new URL(queryString),
            params = new URLSearchParams(url.search);
        id = params.get('id');
    }

    if (!id)
        window.open('/', '_self');

    var isDev = document.getElementById('app-offer-erecruter').dataset.dev == 'true';
console.log(isDev,'isDev?')

    var erecruterApp = new Vue({
        el: '#app-offer-erecruter',
        data: {
            settings: {
                // url: process.env.API_URL,
                url: 'https://api.magentateam.pl',
                key: '7dfgf63-k12yrr-pg8m4s-ob88v5',
                loaderClassName: null, //'lds-ripple',
                loaderVisibleClassName: 'is-visible',
                contentClassName: 'c-results',
            },
            offer: null,
            similar: []
        },
        mounted: function () {
            this.getOfferData();
            this.getSimilarOffers();
        },
        computed: {
            similarOffers: function () {
                return this.similar.slice(0, 4);
            },
            showBenefits: function () {
                if(!this.offer)
                    return false;
                if(!this.offer.hide_benefits)
                    return true;

                if(this.offer.hide_benefits == 'TAK')
                    return false;

                return true;
            },
            plFormOfEmployment: function () {
                if(!this.offer)
                    return '';

                if(this.offer.form_of_employment == 'Employment contract') {
                    return 'Umowa o pracę';
                }

                if(this.offer.form_of_employment == 'B2B contract') {
                    return 'B2B';
                }

                if(this.offer.form_of_employment == 'Civil contract') {
                    return 'Umowa zlecenie';
                }

                return this.offer.form_of_employment;
            }
        },
        methods: {
            getOfferData() {
                this.request("/api/show/" + this.settings.key + '/' + id, (data) => {
                    // console.log(data)
                    this.offer = data;

                    function isTemplate2 (category) {
                        return !isTemplate1(category) && !isTemplate3(category);
                    }

                    function isTemplate1 (category) {
                        return [
                            'contact center',
                            'sprzedaż i obsługa klienta - contact center',
                            'sklepy firmowe',
                            'sprzedaż i obsługa klienta - sklepy firmowe',
                            'reklamacje',
                            'sprzedaż i obsługa klienta - reklamacje',
                            'obsługa klienta online',
                            'sprzedaż i obsługa klienta - obsługa klienta online'
                        ].includes(category.toLowerCase());
                    }

                    function isTemplate3 (category) {
                        return [
                            't hub',
                            '#thub'
                        ].includes(category.toLowerCase());
                    }

                    let area = '';

                    if(this.offer.area && this.offer.area.length){
                        let cat;
                        for (let name in this.offer.area) {
                            if (isTemplate1(this.offer.area[name])) {
                                cat = this.offer.area[name];
                                break;
                            }
                        }

                        if(!cat){
                            for (let name in this.offer.area) {
                                if (isTemplate3(this.offer.area[name])) {
                                    cat = this.offer.area[name];
                                    break;
                                }
                            }
                        }

                        if(cat){
                            area = cat;
                        }
                    }


                    if(isDev) {
                        if (location.href.indexOf('ogloszenie-01.html') !== -1) {
                            if (!isTemplate1(area) && isTemplate2(area)) {
                                location.href = 'ogloszenie-02.html?id=' + id;
                            } else if (!isTemplate1(area) && isTemplate3(area)) {
                                location.href = 'ogloszenie-03.html?id=' + id;
                            }
                        }

                        if (location.href.indexOf('ogloszenie-02.html') !== -1) {
                            if (!isTemplate2(area) && isTemplate3(area)) {
                                location.href = 'ogloszenie-03.html?id=' + id;
                            } else if (!isTemplate2(area) && isTemplate1(area)) {
                                location.href = 'ogloszenie-01.html?id=' + id;
                            }
                        }

                        if (location.href.indexOf('ogloszenie-03.html') !== -1) {
                            if (!isTemplate3(area) && isTemplate2(area)) {
                                location.href = 'ogloszenie-02.html?id=' + id;
                            } else if (!isTemplate3(area) && isTemplate1(area)) {
                                location.href = 'ogloszenie-01.html?id=' + id;
                            }

                            //set english lang attribute
                            if (this.offer.language == 'ENG') {
                                document.documentElement.lang = 'en-GB';
                            }

                        }
                    }
                    else {
                        if (this.offer.language == 'ENG') {
                            document.documentElement.lang = 'en-GB';
                        }
                    }


                    if(this.showBenefits){
                        setTimeout(window.scrollbarCarousel );
                        setTimeout(window.hubbenefits_carousel );
                    }

                    //set meta data
                    document.title = this.offer.title;
                });
            },
            getSimilarOffers() {
                this.request("/api/similar/" + this.settings.key + '/' + id, (data) => {
                    // console.log(data)
                    this.similar = data;
                });
            },
            goTo: function (url) {
                window.open(url, '_self');
            },
            request: function (url, callback) {
                let request = new XMLHttpRequest();
                let that = this;
                // that.showPreloader();
                // that.hideList();
                request.onreadystatechange = function () {
                    if (request.readyState === 4 && request.status === 200) {
                        // that.hidePreloader();
                    } else {
                        // that.showPreloader();
                    }
                }

                request.open('GET', this.settings.url + url, true);

                request.onload = function () {
                    if (this.status >= 200 && this.status < 400) {
                        callback(JSON.parse(this.response))
                    } else {
                        window.open('/index.html', '_self')
                    }
                };
                request.send();
            }
        }
    });
}
